import toServiceObject from './toServiceObject';
import Task from '../schema/Task';
import { Todo } from 'owa-todo-types';

export default function getPartialTaskFromTodo(
    todoUpdates: Partial<Todo>,
    ignoreNullValues?: boolean
): Partial<Task> {
    return toServiceObject(todoUpdates, ignoreNullValues);
}
